/*
 * @Author: Wang Bingjing
 * @Date: 2021-02-22 15:27:48
 * @LastEditTime: 2021-06-30 13:58:03
 * @LastEditors: zhengfan
 */
import React, { useEffect, useContext, useState, Suspense, lazy } from 'react'
import '@alifd/next/dist/next.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import userApi from './api/userApi'

import {
  HashRouter as Router,
  Redirect,
  Route,
  Switch
} from "react-router-dom"
import AppWrapper from './components/AppWrapper'

import { UserProvider } from './store/userStore'
import { SerachPropsProvider } from './store/searchPropStore'
import { TrackPropsProvider } from './store/trackPropStore'
import { OverallContext, SET_SELECTED_SELLER } from './store/overallStore'

// 💤 页面组件懒加载
const TotalState = lazy(() => import('./pages/TotalState'))
const TotalTrend = lazy(() => import('./pages/TotalTrend'))
const HospitalModel = lazy(() => import('./pages/HospitalModel'))
const RobotDataContainer = lazy(() => import('./pages/RobotDataContainer'))
const NotDeployingRobotCards = lazy(() => import('./pages/NotDeployingRobotCards'))
const HospitalCards = lazy(() => import('./pages/HospitalCards'))
const GrowthAnalysis = lazy(() => import('./pages/growthAnalysis/GrowthAnalysis'))
const AbnormalStatisticCharts = lazy(() => import('./pages/abnormalStatistic/AbnormalStatisticCharts'))
const Login = lazy(() => import('./pages/login/Login'))
const AdminUsers = lazy(() => import('./pages/settings/AdminUsers'))
const UsersRecord = lazy(() => import('./pages/settings/UsersRecord'))
const AbnormalAnalysis = lazy(() => import('./pages/abnormalAnalysis/AbnormalAnalysis'))
const IndexDispose = lazy(() => import('./pages/IndexDispose'))
const SalesRanking = lazy(() => import('./pages/salesRanking/salesRanking'))
const HospitalReport = lazy(() => import('./pages/exportHospitalReport/HospitalReport'))
const LogisticsDataAnalysis = lazy(() => import('./pages/logisticsDataAnalysis'))
const OperationalRanking = lazy(() => import('./pages/operationalRanking/OperationalRanking'))
const Activation = lazy(() => import('./pages/Activation'))
const LifeCycleRecord = lazy(() => import('./pages/LifeCycleRecord'))
const WarehouseData = lazy(() => import('./pages/warehouseData/WarehouseData'))
const BehaviorManagementData = lazy(() => import('./pages/behaviorManagementData/BehaviorManagementData'))


export default function App() {
  //remove staff cookie on first load or reload
  const { overallInfo, dispatch } = useContext(OverallContext);
  useEffect( async () => {
    await userApi.setStaff({ staff: '' })
    dispatch({
      type: SET_SELECTED_SELLER,
      payload: { selectedSeller: '',role:'[]' }
    }) 
  }, [])

  return (
    <Suspense fallback={<div>Loading...</div>}>
    <Router>
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route path="/abnormal-statistic-charts" component={AbnormalStatisticCharts} />
        <AppWrapper>
          <Route exact path="/">
            <Redirect to="/total-state" />
          </Route>
          <Route path="/total-state" component={TotalState} />
          <Route path="/user-setting" component={() => (<UserProvider><AdminUsers /></UserProvider>)} />
          <Route path="/user-record" component={() => (<UserProvider><UsersRecord /></UserProvider>)} />
          <Route path="/total-trend" component={TotalTrend} />
          <Route path="/hospital-model" component={HospitalModel} />
          <Route path="/robotData" component={RobotDataContainer} />
          <Route path="/life-cycle/:sn" component={LifeCycleRecord} />
          <Route path="/notDeploying-robotData" component={NotDeployingRobotCards} />
          <Route path="/sales-rank" component={SalesRanking}/>
          <Route path="/activation" component={Activation}/>
          <Route path="/hospitalCards" component={() => (<UserProvider><HospitalCards/></UserProvider>)} />
          <Route path="/warehouseData" component={WarehouseData} />
          <Route path="/hospital-report" component={HospitalReport}/>
          <Route path="/logistics-analysis" component={LogisticsDataAnalysis}/>
          <Route path="/behavior-management-data" component={BehaviorManagementData}/>
          <Route path="/operational-ranking" component={OperationalRanking}/>
          <Route
            path="/abnormal-analysis"
            component={(props) => (<SerachPropsProvider><AbnormalAnalysis {...props} /></SerachPropsProvider>)}
          />
          <Route
            path="/growth-analysis"
            component={(props) => (<TrackPropsProvider><GrowthAnalysis {...props} /></TrackPropsProvider>)}
          /> 
          <Route path="/index-dispose" component={IndexDispose} />
        </AppWrapper>
      </Switch>
    </Router>
    </Suspense>
  );
}
